import { getAwsApiBaseUrl, getCompany } from 'helpers/getCompanyVariables';

const company = getCompany();
const awsApiBaseUrl = getAwsApiBaseUrl();

let endpoints = {};

if (company === 'oneill') {
  endpoints = {
    awsProxy: {
      safePost: `${awsApiBaseUrl}/scripts/SafePortalProxy`,
      genericPost: `${awsApiBaseUrl}/scripts/GenericPortalProxy`
    },
    zoho: {
      getPortalToken: 'portal_auth',
      updateAgentWithPortalPassword: 'updaterecordwithportalpass',
      updatePortalNote: 'manageportalnotes',
      updateActionItem: 'manageactionitems',
      getDashboardData: 'getdashboarddata',
      getAgent: 'get_agent_data',
      getCarriersAndAppointments: 'get_carriers_and_appointments',
      getMarketingAnnouncements: 'getmarketingannouncements',
      manageLeadsForAgent: 'manageleadsforagent',
      // Commissions
      getCommissions: 'portal_commissions',
      getBonus: 'portal_bonus',
      downloadCommissionsDataLocal:
        'http://localhost:5001/o-neill-marketing-portal/us-central1/runCommissionStatement',
      downloadCommissionsData:
        'https://us-central1-o-neill-marketing-portal.cloudfunctions.net/runCommissionStatement',
      // others
      sendEmailsAgentInfo: 'portal_send_agent_emails',
      getNotifications: 'portal_notifications',
      getPushNotifications: 'portal_get_push_notifications',
      updatePushNotificationStatus: 'portal_update_push_notification',
      uploadProfilePic: 'portal_save_agent_photo',
      sendPurchaseMoreLeadsForm: 'portal_purchase_leads',
      // Appointments
      createAppointmentRequest: 'create_appointment_request',
      createNeoContractingRequest: 'create_neo_appointment_request',
      updateSpecificAppointmentStatus:
        'portal_updatespecificappointment_agentstatus',
      getPendingAppointments: 'portal_get_pending_appointments_for_report',
      updateAppointmentCredentials: 'portal_update_appointment_credentials',
      updateAppointmentFromPortal: 'portal_update_appointment_from_portal',
      // Agency management
      getAgentsTree: 'recursive_endpoint',
      getSpecificAgencyData: 'portal_get_specific_agency_data',
      updateAgencyFormPreferences: 'portal_updatehidefields',
      sendAgencyFormEmail: 'portal_sendemail_to_each_agentagency',
      sendEditAgencyInfoFormToAgent: 'portalsendeditagencyinfolink',
      logOnboardingEmails: 'log_onboarding_email_api',
      getOnboardingRecords: 'get_onboarding_records',
      cancelOnboarding: 'cancel_onboarding',
      cancelOnboardingBulk: 'cancel_onboarding_bulk',
      getFAQS: 'portalgetfaqs',
      getCarrierFAQS: 'portalgetcarrierresources',
      getNewsAndIndustryIntel: 'get_news_and_industry_intel',
      getCarierPartners: 'portal_carrier_partners',
      // pop-ups
      getPopUp: 'get_pop_up',
      markPopUpAsRead: 'update_pop_up_read_status',
      getPopUps: 'get_pop_ups',
      // calendar events
      editAgentCalendarEvents: 'edit_agent_calendar_events',
      // marketing assets
      getMarketingAssets: 'get_marketing_assets',
      createLeadPartnersEntry: 'create_lead_partners_entry',
      // offboarding
      createOffboardingRecord: 'create_off_record',
      offboardingZohoSign: 'offboarding_zoho_sign',
      getAgentsWithOpenOffboarding: 'get_agents_with_open_offboarding',
      approveOrDenyOffboardingProcessSecondApproval:
        'approve_or_deny_offboarding_process_second_approva',
      // portal walkthrough
      recordTourSection: 'portal_tour_section_record',
      // agency recommendations
      agencyRecommendationsEmail: 'agency_recommendations_email',
      getAgentsWithApptInfo: 'get_agents_w_appt_info'
    },
    aws: {
      getAgencyTree: '/agencies/tree',
      getSpecificAgencyData: '/agencies',
      selectedAgencies: '/agencies/selected',
      selectedAgenciesAgents: '/agencies/selectedagents',
      carrierMissingAppointments: '/agencies/carrier-missing-appointments',
      notAppointedPolicies: '/agencies/not-appointed-policies',
      stateLeaderMissingAppointments:
        '/agencies/state-leader-missing-appointments',
      saveRecommendedRecommendation: '/agencies/recommendations/recommended',
      getAppointmentsReport: '/agents/appointments/report',
      getAppointmentsCount: '/agents/appointments/count',
      downloadCommissionsData: '/callidusstatements/bulk',
      downloadCommissionsDataLegacy: '/commissions/legacy',
      comissionsPeriods: '/callidusstatements/periods',
      dashboardForPayee: '/callidusstatements/dashboard-for-payee',
      downloadBookOfBusinessData: '/callidusBooksofbusinessObtainer/bulkk',
      downloadBookOfBusinessDataDownload:
        '/callidusbooksofbusinessObtainer/download',
      downloadBookOfBusinessDataDelete:
        '/callidusbooksofbusinessObtainer/delete',
      getBobTabData: '/callidusbooksofbusinessObtainer/tabdata',
      BOBtabdataCsv: '/callidusbooksofbusinessObtainer/tabdatacsv',
      getRetentionRate: '/callidusbooksofbusinessObtainer/retentionRate',
      HStabdata: '/HealthSherpa/tabdata',
      CustomersCommissions: '/customers/commissionsTab',
      BobCommissionReconciliation:
        '/callidusbooksofbusinessObtainer/policiesCommissionReco',
      HStabdataCsv: '/HealthSherpa/tabdatacsv',
      HSignoreCarrier: '/HealthSherpa/ignorecarrier',
      HSunignoreCarrier: '/HealthSherpa/unignorecarrier',
      HSignorePolicy: '/HealthSherpa/ignorePolicy',
      HSunignorePolicy: '/HealthSherpa/unignorePolicy',
      HScarrierInProgress: '/HealthSherpa/carrierinprogress',
      HSemailedCarrierPolicy: '/HealthSherpa/emailedCarrierPolicy',
      HSGetPotentialBobMatches: '/HealthSherpa/getPotentialBobMatches',
      HSGetPotentialBobMatchesBulk: '/HealthSherpa/getPotentialBobMatches/bulk',
      HSRemoveCurrentAssociation: '/HealthSherpa/removeCurrentAssociation',
      HSConfirmCurrentAssociation: '/HealthSherpa/confirmCurrentAssociation',
      HSRevalidateStatuses: '/HealthSherpa/revalidateStatuses',
      BookOfBussinessLastUpdateDate: '/callidusbooksofbusiness/lastupdate',
      BookOfBusinessDownloadLinks:
        '/callidusbooksofbusinessObtainer/downloadLinks',
      saveAgencyFields: '/agencies/updatefields',
      sendMFAResetCode: '/agents/sendOtpCodeMfa',
      validateMFAResetCode: '/agents/validateOtpCodeMfa',
      addPhoneNumberToMfa: '/agents/addPhoneNumberToMfa',
      // bulk onboarding invites (ONEILL-886) — O'Neill only
      bulkOnboardingInvite: '/onboarding/bulk-invite'
    }
  };
}
if (company === 'sunshine') {
  endpoints = {
    awsProxy: {
      safePost: 'https://sunshinelifehealthapi.com/scripts/SafePortalProxy',
      genericPost:
        'https://sunshinelifehealthapi.com/scripts/GenericPortalProxy'
    },
    zoho: {
      getPortalToken: 'portal_auth',
      updateAgentWithPortalPassword: 'updaterecordwithportalpass',
      updatePortalNote: 'manageportalnotes',
      updateActionItem: 'manageactionitems',
      getDashboardData: 'getdashboarddata',
      getAgent: 'get_agent_data',
      getCarriersAndAppointments: 'get_carriers_and_appointments',
      getMarketingAnnouncements: 'getmarketingannouncements',
      manageLeadsForAgent: 'manageleadsforagent',
      // Commissions
      getCommissions: 'portal_commissions',
      getBonus: 'portal_bonus',
      downloadCommissionsDataLocal:
        'http://localhost:5001/o-neill-marketing-portal/us-central1/runCommissionStatement',
      downloadCommissionsData:
        'https://us-central1-o-neill-marketing-portal.cloudfunctions.net/runCommissionStatement',
      // others
      sendEmailsAgentInfo: 'portal_send_agent_emails',
      getNotifications: 'portal_notifications',
      uploadProfilePic: 'portal_save_agent_photo',
      sendPurchaseMoreLeadsForm: 'portal_purchase_leads',
      // Appointments
      createAppointmentRequest: 'create_appointment_request',
      updateSpecificAppointmentStatus:
        'portal_updatespecificappointment_agentstatus',
      // Agency management
      getPendingAppointments: 'portal_get_pending_appointments_for_report',
      getAgentsTree: 'recursive_endpoint',
      getSpecificAgencyData: 'portal_get_specific_agency_data',
      updateAgencyFormPreferences: 'portal_updatehidefields',
      sendAgencyFormEmail: 'portal_sendemail_to_each_agentagency',
      sendEditAgencyInfoFormToAgent: 'portalsendeditagencyinfolink',
      logOnboardingEmails: 'log_onboarding_email_api',
      getFAQS: 'portalgetfaqs',
      getCarrierFAQS: 'portalgetcarrierresources',
      getReconciliationForms: 'getreconciliationforms',
      suncareUpdateAgentInformation: 'suncare_update_agent_information',
      // calendar events
      editAgentCalendarEvents: 'edit_agent_calendar_events',
      // LMS (Zoho Learn) invite — Sunshine only
      inviteToLms: 'portal_invite_to_lms'
    },
    aws: {
      getAgencyTree: '/agencies/tree',
      getSpecificAgencyData: '/agencies',
      selectedAgencies: '/agencies/selected',
      selectedAgenciesAgents: '/agencies/selectedagents',
      getAppointmentsReport: '/agents/appointments/report',
      getAppointmentsCount: '/agents/appointments/count',
      downloadCommissionsData: '/callidusstatements/bulk',
      comissionsPeriods: '/callidusstatements/periods',
      dashboardForPayee: '/callidusstatements/dashboard-for-payee',
      downloadBookOfBusinessData: '/callidusBooksofbusinessObtainer/bulkk',
      downloadBookOfBusinessDataDownload:
        '/callidusbooksofbusinessObtainer/download',
      downloadBookOfBusinessDataDelete:
        '/callidusbooksofbusinessObtainer/delete',
      getBobTabData: '/callidusbooksofbusinessObtainer/tabdata',
      BOBtabdataCsv: '/callidusbooksofbusinessObtainer/tabdatacsv',
      getRetentionRate: '/callidusbooksofbusinessObtainer/retentionRate',
      saveAgencyFields: '/agencies/updatefields',
      HStabdata: '/HealthSherpa/tabdata',
      CustomersCommissions: '/customers/commissionsTab',
      BobCommissionReconciliation:
        '/callidusbooksofbusinessObtainer/policiesCommissionReco',
      HStabdataCsv: '/HealthSherpa/tabdatacsv',
      HSignoreCarrier: '/HealthSherpa/ignorecarrier',
      HSunignoreCarrier: '/HealthSherpa/unignorecarrier',
      HSignorePolicy: '/HealthSherpa/ignorePolicy',
      HSunignorePolicy: '/HealthSherpa/unignorePolicy',
      HScarrierInProgress: '/HealthSherpa/carrierinprogress',
      HSemailedCarrierPolicy: '/HealthSherpa/emailedCarrierPolicy',
      HSGetPotentialBobMatches: '/HealthSherpa/getPotentialBobMatches',
      HSGetPotentialBobMatchesBulk: '/HealthSherpa/getPotentialBobMatches/bulk',
      HSRemoveCurrentAssociation: '/HealthSherpa/removeCurrentAssociation',
      HSConfirmCurrentAssociation: '/HealthSherpa/confirmCurrentAssociation',
      HSRevalidateStatuses: '/HealthSherpa/revalidateStatuses',
      BookOfBussinessLastUpdateDate: '/callidusbooksofbusiness/lastupdate',
      BookOfBusinessDownloadLinks:
        '/callidusbooksofbusinessObtainer/downloadLinks',
      reconciliationTemplate: '/reconciliation',
      // call reviews: get files from Conversely
      callReviewsFiles: '/conversely-analysis-files'
    }
  };
}

export default endpoints;
